import { StoreState } from '../../../app/app.reducers';
import { getPlaceIndex } from './geolocation.logic';
import { MapBoxPlace } from './geolocation.model';

export const getAutocompletePlacesSelectOptions = (valuePlace: MapBoxPlace | undefined) => (
  state: StoreState
) =>
  state.geolocation.autocompletePlacesSelectOptions
    ? state.geolocation.autocompletePlacesSelectOptions[getPlaceIndex(valuePlace)]
    : [];
